import { render, staticRenderFns } from "./SwitchWithTooltip.vue?vue&type=template&id=03c83096&scoped=true"
import script from "./SwitchWithTooltip.vue?vue&type=script&lang=ts"
export * from "./SwitchWithTooltip.vue?vue&type=script&lang=ts"
import style0 from "./SwitchWithTooltip.vue?vue&type=style&index=0&id=03c83096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c83096",
  null
  
)

export default component.exports